import { ProductEnergy, ProductQtyErrorCode } from '../../../../../generated/graphql';
import { ILabel } from '../../../models/common/label.model';
import { IPrice } from '../../../models/common/pricing/price.model';
import { IStock } from '../../../models/common/stock.model';
import { Locale } from '../../../models/master/context-info.model';
import { IPDPCalibration } from '../../../models/pdp/pdp-calibration.model';
import { IPDPMedia } from '../../../models/pdp/pdp-media.model';
import { IPDPPPK } from '../../../models/pdp/pdp-ppk.model';
import { IPDPPricing } from '../../../models/pdp/pdp-pricing.model';
import { IPDPProductPricing } from '../../../models/pdp/pdp-product-pricing.model';
import { IPricingService } from '../../../services/pricing/pricing-service';
import { IProductService } from '../../../services/product/product-service';

export type PriceAreaProps = {
  labels?: ILabel[] | null;
  allowAddToPartsList?: boolean; //TODO: check if required since it is not being used
  titleArea?: { title?: string; stockCode: string } | null;
  priceArea: IPDPPricing;
  ppkArea?: IPDPPPK | null;
  stockArea?: IStock | null;
  isBarred: boolean;
  isDualUse: boolean;
  selectedPriceBreakIndex?: number;
  mediaArea?: IPDPMedia | null;
  energyArea?: ProductEnergy | null;
  calibrationArea?: IPDPCalibration | null;
  isInFixedCTA?: boolean;
  pricingService: IPricingService;
  locale: Locale;
  euElrProductInformationSheet?: { callNum: number; url?: string };
  productService?: IProductService;
  isInBasket: boolean;
  onQtyChange?: (qty?: number) => void;
  onAddToBasketClick: (qty: number) => Promise<void>;
  onAddToPartsListClick?: () => void;
  onQtyDropdownClick?: (isOpen: boolean) => void;
  onPackagingChange: (stockCode: string) => void;
  onCalibrationChange: (stockCode: string) => void;
  onEnergyModalToggle?: (isOpen: boolean) => void;
  onUnavailableEnergyProductInfoSheetBtnClick?: () => void;
};

export type State = {
  quantity: number;
  isValidQty: boolean;
  isBusy: boolean;
  selectedPriceBreakIndex?: number;
  unlistedQuantityPrice?: IPDPProductPricing;
  totalPriceIncVat?: IPrice;
  totalPriceExVat?: IPrice;
  dualPriceIncVat?: IPrice;
  dualPriceExVat?: IPrice;
  isSearchingUnlistedQuantity?: boolean;
  defaultDropdownSelection?: number;
  errorMessage?: string;
  isDropdownOpen: boolean;
  lastPropPricesFirstPriceQty: number;
  lastPropPricesFirstTotalPrice: IPrice;
  isCalibrationDropdownOpen: boolean;
  isPPKDropdownOpen: boolean;
  isCalibrationChanging: boolean;
};

export enum AddToBasketCTAActionType {
  SetPriceBreakIndex = 'SetPriceBreakIndex',
  IsBusy = 'IsBusy',
  SetUnlistedQuantityPrice = 'SetUnlistedQuantityPrice',
  SearchUnlistedQuantity = 'SearchUnlistedQuantity',
  SetInvalidUnlistedQty = 'SetInvalidUnlistedQty',
  SearchListedQuantity = 'SearchListedQuantity',
  ToggleDropdown = 'ToggleDropdown',
  UpdateDefaultDropdownSelection = 'UpdateDefaultDropdownSelection',
  SetIsCalibrationDropdownOpen = 'SetIsCalibrationDropdownOpen',
  SetIsPPKDropdownOpen = 'SetIsPPKDropdownOpen',
  SetPrice = 'SetPrice',
  CalibrationChange = 'CalibrationChange',
}

export type Action =
  | { type: AddToBasketCTAActionType.SetPriceBreakIndex; index?: number }
  | { type: AddToBasketCTAActionType.IsBusy; isBusy: boolean; isDropdownOpen?: boolean }
  | { type: AddToBasketCTAActionType.SetUnlistedQuantityPrice; qty: number; price?: IPDPProductPricing; message?: string }
  | { type: AddToBasketCTAActionType.SearchUnlistedQuantity; quantity: number }
  | { type: AddToBasketCTAActionType.SetInvalidUnlistedQty; quantity: number; errorCode: ProductQtyErrorCode }
  | { type: AddToBasketCTAActionType.SearchListedQuantity; quantity?: number; isDropdownOpen?: boolean }
  | { type: AddToBasketCTAActionType.UpdateDefaultDropdownSelection }
  | { type: AddToBasketCTAActionType.SetIsCalibrationDropdownOpen; isOpen: boolean }
  | { type: AddToBasketCTAActionType.SetIsPPKDropdownOpen; isOpen: boolean }
  | {
      type: AddToBasketCTAActionType.SetPrice;
      qty: number;
      totalPriceIncVat?: IPrice;
      totalPriceExVat?: IPrice;
      dualPriceIncVat?: IPrice;
      dualPriceExVat?: IPrice;
    }
  | { type: AddToBasketCTAActionType.CalibrationChange; isChanging: boolean };
